import {config} from '@src/config';
import { initializeApp } from "firebase/app"

const firebaseApp = initializeApp(config.firebase);
export {firebaseApp};

